module.exports = __webpack_public_path__ + "img/6_87.f283619b.png";